import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { DownloadCard } from './SlmReports';
import DailyCensusDownload from './downloads/daily-census';

const CensusReports = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography
        sx={{ marginBottom: 3 }}
        fontSize={30}
        color={'#111927'}
        fontWeight={600}
      >
        Census
      </Typography>

      <Grid
        container
        spacing={3}
      >
        <DownloadCard
          title="Daily Census Report"
          description={{}}
        >
          <DailyCensusDownload />
        </DownloadCard>
      </Grid>
    </Box>
  );
};

export default CensusReports;
